import { memo, ReactElement } from 'react';

import { StyledTooltip } from '@/modules/common/components/StyledTooltip';

const WRAPPER_STYLE = { display: 'block', width: '100%' };

type Props = {
  /** Translation key explaining why the field is disabled; undefined when it is editable */
  reasonKey?: string;
  children: ReactElement;
};

/**
 * @description Shows why a property field is disabled, e.g. when it only applies to part of
 * the selection. The wrapper is needed because disabled elements don't fire mouse events.
 */
function DisabledReasonTooltipComponent({ reasonKey, children }: Props) {
  return (
    <StyledTooltip
      titleKey={reasonKey}
      placement='top'
      disabled={reasonKey !== undefined}
      openOnlyWhenDisabled
    >
      <span style={WRAPPER_STYLE}>{children}</span>
    </StyledTooltip>
  );
}

export const DisabledReasonTooltip = memo(DisabledReasonTooltipComponent);
